














































import { ModuleStatus } from '@/jbi-shared/types/jtms.types';
import { ModuleResponseDTO } from '@/store/modules/jtms/module/module.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({})
export default class ModuleDropdown extends Vue {
  // Standard 'value' prop for v-model
  @Prop({ type: Object, default: null })
  readonly value!: ModuleResponseDTO | null;

  clonedActiveModules: ModuleResponseDTO[] = [];

  @Action('module/getModules')
  getModules!: () => void;

  @State((state: RootState) => state.module.modules)
  allModules!: ModuleResponseDTO[];

  @State((state: RootState) => state.module.apiState.getModules)
  getModulesApiState!: ApiState;

  searchTerm: string = '';

  get filteredModules() {
    return this.clonedActiveModules.filter(
      (module: ModuleResponseDTO) =>
        module.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
    );
  }

  created() {
    if (!this.allModules) {
      this.getModules();
    }
    this.cloneToLocalVariable();
  }

  // Event handler that emits the 'input' event
  @Emit('input')
  onValueChanged(newValue: ModuleResponseDTO) {
    return newValue;
  }

  @Watch('getModulesApiState.success')
  cloneToLocalVariable() {
    if (this.allModules) {
      // Only ACTIVE modules can be selected
      this.clonedActiveModules = this.allModules.filter(
        (module) => module.status === ModuleStatus.ACTIVE
      );
    }
  }
}
